import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { map, mergeMap,exhaustMap } from "rxjs/operators";
import { DocumentService } from "../../services/document.service";
import { DocumnentTypes } from './document-actions'


@Injectable()
export class DocumentEffects {

    id!: string;
    dbname!: string;

    loadDocument = createEffect(() =>
        this.actions$.pipe(
            ofType(DocumnentTypes.InvokeDocumentApiType),
            // mergeMap((action: any) => {
                exhaustMap((action: any) => {
                return this.documentService.getDocument(action.id, action.dbname)
                    .pipe(map((data) => ({ type: DocumnentTypes.RetrieveDocumentType, document: data })));
            })));

    constructor(private actions$: Actions, private documentService: DocumentService) { }
}